<template>
  <div class="personal-info-container">
    <div class="form-card">
      <h2 class="form-title">个人信息</h2>
      <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
        class="info-form"
        :size="formSize"
        status-icon
      >
        <el-form-item label="昵称" prop="name">
          <el-input 
            v-model="ruleForm.name" 
            :disabled="isDisabled"
            placeholder="请输入昵称"
          />
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input 
            v-model="ruleForm.phone" 
            :disabled="isDisabled"
            placeholder="请输入手机号码"
          />
        </el-form-item>
        <el-form-item label="单位" prop="company">
          <el-input 
            v-model="ruleForm.company" 
            :disabled="isDisabled"
            placeholder="请输入单位名称"
          />
        </el-form-item>

        <el-form-item class="form-buttons">
          <el-button 
            type="success" 
            :icon="Edit"
            @click="editUserInfo"
            v-if="isDisabled"
          >
            修改信息
          </el-button>
          <el-button 
            type="primary" 
            :icon="Check"
            @click="submit"
            v-else
          >
            保存修改
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import type { ComponentSize, FormInstance } from "element-plus";
import { ElMessage } from "element-plus";
import { Edit, Check } from '@element-plus/icons-vue'
import { getUserInfo, updateUserInfo } from "../../api";
import { useRouter } from 'vue-router';

interface IUserInfo {
  name: string;
  phone: string;
  company: string;
}

const router = useRouter();
const isDisabled = ref(true);
const formSize = ref<ComponentSize>("default");
const ruleFormRef = ref<FormInstance>({} as FormInstance);

const ruleForm = ref({
  name: "",
  phone: "",
  company: "",
});

const rules = {
  name: [
    { required: true, message: "请输入昵称" },
    { min: 1, max: 30, message: "昵称长度应在1-30个字符之间" },
  ],
  phone: [
    { required: true, message: "请输入手机号码" },
    // {
    //   pattern: /^\d{11}$/,
    //   message: "请输入正确的11位手机号码",
    // },
  ],
  company: [{ required: true, message: "请输入单位名称" }],
};

const getUserInfoData = async () => {
  const res = await getUserInfo();
  if (res?.code === "success") {
    ruleForm.value = res.content as IUserInfo;
  }
};

const editUserInfo = () => {
  isDisabled.value = false;
};

const logout = () => {
  localStorage.removeItem('userInfo');
  router.push('/login');
  ElMessage({
    message: "退出登录成功",
    type: "success"
  });
};

const submit = async () => {
  const valid = await ruleFormRef.value
    .validate()
    .then(() => true)
    .catch(() => false);
  if (!valid) return;

  const res = await updateUserInfo(ruleForm.value);
  if (res?.code === "success") {
    ElMessage({
      message: "个人信息修改成功",
      type: "success",
    });
    isDisabled.value = true;
    // 刷新用户信息
    await getUserInfoData();
    // 自动退出登录
    setTimeout(() => {
      logout();
    }, 1000);
  }
};

onMounted(() => {
  getUserInfoData();
});
</script>

<style scoped>
.personal-info-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 200px);
  padding: 20px;
  background-color: #f5f7fa;
}

.form-card {
  width: 600px;
  padding: 30px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.form-title {
  text-align: center;
  color: #303133;
  margin-bottom: 30px;
  font-weight: 500;
}

.info-form {
  max-width: 500px;
  margin: 0 auto;
}

.form-buttons {
  margin-top: 30px;
  text-align: center;
}

.el-button {
  padding: 12px 25px;
  font-size: 14px;
}

.el-input {
  transition: all 0.3s ease;
}

.el-input:hover {
  transform: translateY(-1px);
}

:deep(.el-form-item__label) {
  font-weight: 500;
}
</style>
